import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Col, Row, Card } from "react-bootstrap";
import "../utils/index.css";
import ReactCountryFlag from "react-country-flag";

const SimulerChangementBusinessModal = ({ show, onClose, commission, onApply,commissionsBusiness }) => {
  // State pour inputs
  const [montant, setMontant] = useState(0);
  const [nouveauPayIn, setNouveauPayIn] = useState(0);
  const [nouveauPayOut, setNouveauPayOut] = useState(0);

  // Sync avec la commission quand modal ouvert
  useEffect(() => {
    if (commission && show) {
      setNouveauPayIn(commission.payinCommissionPercentage || 0);
      setNouveauPayOut(commission.payoutCommissionPercentage || 0);
      setMontant(0); // reset du montant
    }
  }, [commission, show]);
 if (!commission) return null;
const { country, method: paymentMethod, payinCommissionPercentage, payoutCommissionPercentage } = commission;
// Vérification sécurisée dans commissionsBusiness
// ✅ Recherche de la commission détaillée correspondante
let commissionDetail = null;

// Étape 1 : récupérer la liste à l'intérieur de commissionsBusiness
const allBusinesses = Array.isArray(commissionsBusiness)
  ? commissionsBusiness
  : Object.values(commissionsBusiness).flat();

// Étape 2 : trouver le pays correspondant
const countryData = allBusinesses.find(
  (entry) => entry.country === country
);

// Étape 3 : trouver la méthode correspondante
if (countryData && Array.isArray(countryData.paymentMethods)) {
  commissionDetail = countryData.paymentMethods.find((m) => {
    const payMethod = m.paymentMethod?.toLowerCase?.() || "";
    const methodName = paymentMethod?.name?.toLowerCase?.() || "";
    const methodId = paymentMethod?.id?.toLowerCase?.() || "";
    return payMethod === methodName || payMethod === methodId;
  });
}
const actualPayIn = commissionDetail?.payinCommissionPercentage ?? payinCommissionPercentage;
const actualPayOut = commissionDetail?.payoutCommissionPercentage ?? payoutCommissionPercentage;
// Calculs
const calculPayIn = (montant * actualPayIn) / 100;
const calculPayOut = (montant * actualPayOut) / 100;
const calculNouPayIn = (montant * nouveauPayIn) / 100;
const calculNouPayOut = (montant * nouveauPayOut) / 100;

const fraisPayIn = calculPayIn / 2;
const fraisPayOut = calculPayOut / 2;
const fraisNouPayIn = calculNouPayIn / 2;
const fraisNouPayOut = calculNouPayOut / 2;


  // 🔹 Fonction Appliquer
  const handleApply = () => {
    const newData = {
      ...commission,
      payinCommissionPercentage: nouveauPayIn,
      payoutCommissionPercentage: nouveauPayOut,
    };

    // Si un callback est passé par le parent
    if (onApply) {
      onApply(newData);
    }

    onClose(); // ferme le modal après
  };

  // 🔹 Fonction Annuler
  const handleCancel = () => {
    // Reset aux valeurs d’origine
    setNouveauPayIn(commission.payinCommissionPercentage || 0);
    setNouveauPayOut(commission.payoutCommissionPercentage || 0);
    setMontant(0);

    onClose();
  };
  

  return (
    <Modal
  show={show}
  onHide={handleCancel}
  centered
  className="custom-modal"
  size="lg"
  dialogClassName="responsive-modal"
>
  <Modal.Body>
    <div className="titless mb-2">
      <span>Simuler changement</span>
      <div className="methoP">
        <ReactCountryFlag
          countryCode={country}
          svg
          style={{ width: "24px", height: "24px" }}
        />
        <span style={{ marginLeft: "10px", wordBreak: "break-word" }}>
          {country} - {paymentMethod.name || paymentMethod.id}
        </span>
      </div>
      <div className="para">
        Simulez l'impact des changements de commission avant de les appliquer
      </div>
    </div>

    <div style={{ padding: "10px" }}>
      <Form layout="vertical">
        <Form.Group className="mb-3">
          <Form.Label className="labelss">Montant de la transaction</Form.Label>
          <Form.Control
            type="number"
            value={montant}
            onChange={(e) => setMontant(parseFloat(e.target.value) || 0)}
          />
        </Form.Group>

        <Row className="g-2">
          <Col xs={12} md={6}>
            <Form.Group className="mb-3">
              <Form.Label className="labelss">Nouveau taux Pay IN</Form.Label>
              <Form.Control
                type="number"
                value={nouveauPayIn}
                onChange={(e) => setNouveauPayIn(parseFloat(e.target.value) || 0)}
              />
            </Form.Group>
          </Col>
          <Col xs={12} md={6}>
            <Form.Group className="mb-3">
              <Form.Label className="labelss">Nouveau taux Pay Out</Form.Label>
              <Form.Control
                type="number"
                value={nouveauPayOut}
                onChange={(e) => setNouveauPayOut(parseFloat(e.target.value) || 0)}
              />
            </Form.Group>
          </Col>
        </Row>
      </Form>
    </div>

    <Row className="g-2">
      <Col xs={12} md={6}>
        <Card className="mb-3 p-2 border-light">
          <button className="buttonAct mb-3 w-100" style={{ maxWidth: "86px", height: "35px" }}>Actuel</button>
          <Card className="mb-3">
            <div className="labelNoire">Pay In : {calculPayIn.toFixed(2)} XOF</div>
            <div className="labelGris">Taux: {actualPayIn || 0}%</div>
            <div className="labelNoire">Frais OP : {fraisPayIn} XOF</div>
            <div className="labelNoire">Pay IN Agr : {fraisPayIn} XOF</div>
          </Card>
          <Card>
            <div className="labelNoire">Pay Out : {calculPayOut.toFixed(2)} XOF</div>
            <div className="labelGris">Taux: {actualPayOut || 0}%</div>
            <div className="labelNoire">Frais OP : {fraisPayOut} XOF</div>
            <div className="labelNoire">Pay Out Agr : {fraisPayOut} XOF</div>
          </Card>
        </Card>
      </Col>

      <Col xs={12} md={6}>
        <Card className="mb-3 p-2 border-primary">
          <Button className="buttonNou mb-3 w-100" style={{ maxWidth: "89px", height: "35px" }}>Nouveau</Button>
          <Card className="mb-3">
            <div className="labelBleu">Pay In : {calculNouPayIn.toFixed(2)} XOF</div>
            <div className="labelGris">Taux: {nouveauPayIn || 0}%</div>
            <div className="labelBleu">Frais OP : {fraisNouPayIn} XOF</div>
            <div className="labelBleu">Pay IN Agr : {fraisNouPayIn} XOF</div>
          </Card>
          <Card>
            <div className="labelBleu">Pay Out : {calculNouPayOut.toFixed(2)} XOF</div>
            <div className="labelGris">Taux: {nouveauPayOut || 0}%</div>
            <div className="labelBleu">Frais OP : {fraisNouPayOut} XOF</div>
            <div className="labelBleu">Pay Out Agr : {fraisNouPayOut} XOF</div>
          </Card>
        </Card>
      </Col>
    </Row>

    <div className="modal-actions">
      <Button className="buttonSui mb-2 w-100" onClick={handleApply}>
        Appliquer le taux
      </Button>
      <button className="buttonAnn w-100" onClick={handleCancel}>
        Annuler
      </button>
    </div>
  </Modal.Body>
</Modal>

  );
};

export default SimulerChangementBusinessModal;
